"use client";
import { motion, useTransform, useSpring } from "framer-motion";
import Image from "next/image";

const KonfigurasiLogoCard = ({ image, index, scrollYProgress }) => {
  const cardX = useTransform(
    scrollYProgress,
    [0, 0.3 + index * 0.1, 0.5 + index * 0.1, 1],
    ["350%", "0%", "0%", "0%"]
  );
  const smoothCardX = useSpring(cardX, { stiffness: 180, damping: 50 });

  return (
    <motion.div
      className="flex sticky items-center justify-center p-3 md:p-7 lg:p-10 w-full h-16 sm:h-36 lg:h-52 rounded-xl overflow-hidden drop-shadow-md hover:drop-shadow-2xl bg-white/100 backdrop-blur-3xl"
      style={{ x: smoothCardX }}
    >
      <div className="w-full h-full relative">
        <Image
          src={image}
          alt="image"
          className="object-contain"
          fill
          sizes="(max-width: 768px) 150px, 280px"
        />
      </div>
    </motion.div>
  );
};

export default KonfigurasiLogoCard;
